import { Manager } from 'socket.io-client';
import eventEmitter from '@chronos/utils/eventEmitter';

function socketHelper() {
  let socket = null;
  let onlineUsers = {};

  return {
    socket,
    getSocket: () => {
      return socket;
    },
    hasSocket: () => {
      return !!socket;
    },
    getOnlineUsers: () => {
      return onlineUsers;
    },
    on: (name, callback) => {
      socket.on(name, callback);
    },
    off: (name, callback) => {
      socket.off(name, callback);
    },
    close: () => {
      socket.close();
    },
    initialize: ({ chronosJWT, socketUrl }) => {
      const manager = new Manager(socketUrl, {
        autoConnect: false,
        extraHeaders: {
          authorization: chronosJWT,
        },
      });
      socket = manager.socket('/');
    },
    connect: ({ cardId, boardId, memberId }) => {
      socket.on('connect', () => {
        log.info('[socket]:', '🫀', 'connect!');
        socket.emit('subscribeToOrganizationOnlineUsers');
        socket.emit('subscribeOnLiveWorklogs', { boardId, cardId, memberId });
        socket.emit('subscribeToEstimateState', { boardId, cardId });
        log.debug('[socket]:', '🫀', 'subscribeTimerStateRoom');
      });

      socket.on('disconnect', (reason) => {
        log.debug('[socket]:', '🚨', `disconnect! - ${reason}`);
        // Auto reconnect will not be fired
        if (reason === 'io server disconnect') {
          setTimeout(() => {
            if (socket && socket.disconnected) {
              socket.connect();
            }
          }, 5000);
        }
      });

      socket.on('onlineUsers', (socketMessage) => {
        onlineUsers = socketMessage;
      });

      socket.connect();

      /*
      socket.on('reInitilize', () => {
        socket.disconnect();
      });
      */
    },

    emit: (eventName, ...args) => {
      // console.log('eventEmitter.emit', eventName, ...args);
      eventEmitter.emit(eventName, ...args);
    },

    disconnect: () => {
      if (socket) {
        log.debug('[socket]:', '🚨', 'client side disconnect!');
        socket.disconnect();
      }
    },
  };
}

export default socketHelper();
